/* maligo® – Upselling im Warenkorb (Schublade + Warenkorb-Seite), 19.10.2026.
   1) Nächste Mengenstufe mit echtem Vorteil (Stückpreis, Werbe-Kit, Gratisversand, Großkundenpreis) + Knopf zum Erhöhen.
   2) Mengenvorteil gegenüber dem Einstiegspreis als eigene Zeile (kein künstlich durchgestrichener Preis, Omnibus).
   3) Andere Textur mit demselben Logo (Konfigurator merkt sich das Logo).
   Regeln aus CLAUDE.md: Werbe-Kit ab 3 Trays (J30/Butter) bzw. ab 90 Stk (J12), nie 250 ml; 10 % auf Folgebestellungen ab 5 Trays;
   Gratisversand ab 250 €, nicht Schweiz. Texte kommen aus snippets/maligo-cart-upsell.liquid (window.maligoUpsellT). */
(() => {
  if (window.maligoUpsell) return;
  const T = window.maligoUpsellT || {};
  const ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const OWN = { 'X-Maligo-Probe': '1', Accept: 'application/json' };
  const SKU = /^MLG-(J12|J30|J250|B30|BP30)-([A-Z]+)-(\d{3})$/;
  const KIT_FROM = { J30: 72, J12: 90, B30: 81, BP30: 81 };
  const TOP = { J30: 120, B30: 135, BP30: 135 };
  const TRAY = { J30: 24, B30: 27, BP30: 27 };
  const OTHER = { J12: 'B30', J30: 'B30', J250: 'B30', B30: 'J30', BP30: 'J30' };
  const HANDLE = { B30: 'maligo-aftercare-butter', J30: 'maligo-aftercare-jelly' };
  const country = (window.Shopify && Shopify.country) || '';
  const lang = (document.documentElement.lang || 'de').toLowerCase();
  const loc = lang.startsWith('en') ? 'en-IE' : lang === 'pt-pt' ? 'pt-PT' : lang;
  const eur = (c) => new Intl.NumberFormat(loc, { style: 'currency', currency: 'EUR' }).format(c / 100);
  const fill = (s, o) => String(s || '').replace(/\{(\w+)\}/g, (m, k) => (k in o ? o[k] : m));
  const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const qty = (code, u) => (TRAY[code] ? fill(T.trays, { n: u / TRAY[code], u }) : fill(T.units, { u }));
  const productCache = {};

  async function product(handle) {
    if (!productCache[handle]) productCache[handle] = fetch(`${ROOT}products/${handle}.js`, { headers: OWN }).then((r) => r.json());
    return productCache[handle];
  }

  async function model() {
    const cart = await (await fetch(`${ROOT}cart.js`, { headers: OWN })).json();
    const lines = cart.items.map((i) => ({ i, m: (i.sku || '').match(SKU) })).filter((x) => x.m);
    if (!lines.length) return null;
    const codes = lines.map((x) => x.m[1]);
    const out = { cart, tier: null, save: 0, cross: null };
    // Hauptzeile = teuerste Private-Label-Zeile
    const main = lines.sort((a, b) => b.i.final_line_price - a.i.final_line_price)[0];
    const [, code, label, n] = main.m;
    const units = +n;
    const p = await product(main.i.handle);
    const same = p.variants
      .map((v) => ({ v, m: (v.sku || '').match(SKU) }))
      .filter((x) => x.m && x.m[1] === code && x.m[2] === label && x.v.available)
      .map((x) => ({ id: x.v.id, units: +x.m[3], price: x.v.price }))
      .sort((a, b) => a.units - b.units);
    const entry = same[0];
    // Mengenvorteil über alle Private-Label-Zeilen gegenüber dem Einstiegspreis derselben Variante
    for (const x of lines) {
      const pp = await product(x.i.handle);
      const vs = pp.variants.map((v) => ({ v, m: (v.sku || '').match(SKU) })).filter((y) => y.m && y.m[1] === x.m[1] && y.m[2] === x.m[2]).map((y) => ({ u: +y.m[3], p: y.v.price })).sort((a, b) => a.u - b.u);
      if (vs.length) out.save += Math.max(0, Math.round((vs[0].p / vs[0].u) * +x.m[3] * x.i.quantity) - x.i.final_line_price);
    }
    const next = same.find((s) => s.units > units);
    if (next && entry) {
      const perNow = main.i.final_line_price / main.i.quantity / units;
      const perNext = next.price / next.units;
      const perks = [];
      if (KIT_FROM[code] && units < KIT_FROM[code] && next.units >= KIT_FROM[code]) perks.push(T.kit);
      const delta = next.price - main.i.final_line_price / main.i.quantity;
      if (country !== 'CH' && cart.total_price < 25000 && cart.total_price + delta >= 25000) perks.push(T.ship);
      if (TOP[code] && next.units === TOP[code]) perks.push(T.big);
      const extra = next.units - units;
      const saveNext = Math.max(0, Math.round((entry.price / entry.units) * next.units) - next.price);
      out.tier = { key: main.i.key, props: main.i.properties || {}, next, delta, perNow, perNext, perks, code, extra, marginal: delta / extra, saveNext };
    }
    const other = OTHER[code];
    if (other && !codes.some((c) => (other === 'B30' ? /^BP?30$/.test(c) : /^J/.test(c)))) {
      const op = await product(HANDLE[other]);
      const ov = op.variants.map((v) => ({ v, m: (v.sku || '').match(SKU) })).filter((x) => x.m && x.m[2] === 'ORI' && x.v.available).sort((a, b) => +a.m[3] - +b.m[3])[0];
      if (ov) out.cross = { code: other, price: ov.v.price, url: `${ROOT}products/${HANDLE[other]}?konfigurator=1` };
    }
    return out;
  }

  function html(d) {
    let h = '';
    if (d.tier) {
      const t = d.tier;
      const hasKit = t.perks.includes(T.kit);
      const extra = t.perks.length ? `<span class="mgu__perks">${t.perks.map((x) => `✓ ${esc(x === T.kit ? String(T.kit).split(' (')[0] : x)}`).join(' · ')}</span>` : '';
      const sub = t.saveNext > 0 ? ` · ${esc(fill(T.save_up, { s: eur(t.saveNext) }))}` : '';
      const kitImg = hasKit ? `<img class="mgu__img" src="https://cdn.shopify.com/s/files/1/0978/4279/0745/files/Add-on_set.png?width=96" width="44" height="44" alt="${esc(T.kit)}" loading="lazy">` : '';
      h += `<div class="mgu__row">${kitImg}<span class="mgu__txt"><strong>${esc(fill(T.more, { n: t.extra, p: eur(t.marginal) }))}</strong>${sub}${extra}</span>
        <button type="button" class="mgu__btn" data-mgu-up aria-label="${esc(fill(T.btn, { q: qty(t.code, t.next.units), d: eur(t.delta) }))}">+${esc(eur(t.delta))}</button></div>`;
    }
    if (d.cross) {
      const c = d.cross;
      h += `<a class="mgu__row mgu__x" href="${esc(c.url)}"><span class="mgu__txt">${esc(fill(c.code === 'B30' ? T.x_butter : T.x_jelly, { p: eur(c.price) }))}</span><span class="mgu__arr" aria-hidden="true">→</span></a>`;
    }
    return h;
  }

  function saveHtml(d) {
    return d && d.save > 0 ? `<p class="mgu-save" title="${esc(T.save_note)}"><span>${esc(T.save)}</span><strong>−${esc(eur(d.save))}</strong></p>` : '';
  }

  // Kasse-Knopf: „Sicher zur Kasse“ statt „Zur Kasse“ (19.10.2026)
  function checkoutLabel() {
    if (!T.checkout) return;
    document.querySelectorAll('button[name="checkout"]').forEach((b) => {
      const sp = b.querySelector('span');
      if (sp && sp.textContent.trim() !== T.checkout) sp.textContent = T.checkout;
    });
  }

  // Papierkorb in die Preiszeile der Produkte (spart eine Zeile, 19.10.2026)
  function moveTrash() {
    document.querySelectorAll('cart-drawer .cart-item:not(.cart-item--probe)').forEach((r) => {
      const rm = r.querySelector('.cart-item__quantity cart-remove-button');
      const pw = r.querySelector('.cart-item__price-wrapper');
      if (!rm || !pw) return;
      pw.style.position = 'relative';
      rm.classList.add('mgu-rm');
      pw.appendChild(rm);
      r.querySelector('.cart-item__quantity').style.display = 'none';
    });
  }

  // Vertrauens-Kasten unter „Sicher zur Kasse“ (19.10.2026): wirkt am Entscheidungspunkt, spart Platz im Scroll-Bereich
  function moveTrust() {
    const box = document.querySelector('cart-drawer .drawer__cart-items-wrapper .mg-trustbox, cart-drawer cart-drawer-items .mg-trustbox');
    const ctas = document.querySelector('cart-drawer .drawer__footer .mg-ctas, cart-drawer .drawer__footer .cart__ctas');
    if (!box || !ctas) return;
    document.querySelectorAll('cart-drawer .drawer__footer .mg-trustbox').forEach((x) => { if (x !== box) x.remove(); });
    box.classList.add('mgu-trust');
    ctas.after(box);
  }

  let last = null;
  async function render() {
    checkoutLabel();
    moveTrash();
    moveTrust();
    let d;
    try { d = await model(); } catch (e) { return; }
    last = d;
    const targets = [];
    const drawer = document.querySelector('cart-drawer .drawer__footer');
    if (drawer) targets.push({ el: drawer, where: 'beforebegin' });
    const page = document.querySelector('.template-cart cart-items, body.template-cart #main-cart-items, main cart-items');
    if (page && !page.closest('cart-drawer')) targets.push({ el: page, where: 'afterend' });
    for (const t of targets) {
      const host = t.el.parentElement;
      host.querySelectorAll(':scope > .mgu').forEach((x) => x.remove());
      if (!d) continue;
      const markup = html(d);
      if (!markup) continue;
      t.el.insertAdjacentHTML(t.where, `<div class="mgu">${markup}</div>`);
    }
    // Mengenvorteil klein unter die Zwischensumme (Schublade + Seite)
    document.querySelectorAll('.mgu-save').forEach((x) => x.remove());
    // Mengenvorteil steht schon je Zeile („−9 % Du sparst …“), daher hier keine zweite Zeile (19.10.2026)
    // Gratis-Beilagen immer unter die bezahlten Produkte
    document.querySelectorAll('cart-items tbody, .cart-drawer .cart-items, cart-drawer-items .drawer__cart-items-wrapper ul, .cart-items').forEach((list) => {
      const kids = [...list.children];
      const isGift = (r) => Boolean(r.querySelector && r.querySelector('a[href*="-beilage"]'));
      const lastPaid = kids.map(isGift).lastIndexOf(false);
      if (kids.some((r, ix) => isGift(r) && ix < lastPaid)) kids.filter(isGift).forEach((r) => list.appendChild(r));
    });
  }

  async function upgrade(btn) {
    const t = last && last.tier;
    if (!t) return;
    btn.disabled = true; btn.textContent = T.busy;
    try {
      await fetch(`${ROOT}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', ...OWN }, body: JSON.stringify({ items: [{ id: t.next.id, quantity: 1, properties: t.props }] }) });
      await fetch(`${ROOT}cart/change.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', ...OWN }, body: JSON.stringify({ id: t.key, quantity: 0 }) });
      if (window.maligoProbes) { await window.maligoProbes.sync(); await window.maligoProbes.refreshCart(); }
      else location.reload();
    } catch (e) { location.reload(); }
  }

  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-mgu-up]');
    if (b) upgrade(b);
  });
  let timer = null;
  const schedule = () => { clearTimeout(timer); timer = setTimeout(render, 250); };
  new MutationObserver((muts) => {
    if (muts.some((m) => [...m.addedNodes].some((n) => n.nodeType === 1 && !n.classList.contains('mgu') && (n.matches('.cart-item, .drawer__footer, cart-items, tr') || n.querySelector?.('.cart-item'))))) schedule();
  }).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('DOMContentLoaded', schedule);
  if (document.readyState !== 'loading') schedule();
  window.maligoUpsell = { render };
})();
